import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// Overrides Turbo's default browser confirm() with a DaisyUI modal dialog.
// Mounted once in the app layout via shared/_confirm_modal partial.
export default class extends Controller {
  static targets = ["dialog", "header", "description"];

  connect() {
    Turbo.setConfirmMethod((message, element) => {
      const dialog = this.dialogTarget;

      this.headerTarget.innerText =
        element.dataset.confirmHeader || "Are you sure?";
      this.descriptionTarget.innerText = message;

      dialog.showModal();

      return new Promise((resolve) => {
        dialog.addEventListener(
          "close",
          () => {
            resolve(dialog.returnValue === "confirm");
          },
          { once: true },
        );
      });
    });
  }
}
